export const GENDER_FILTER_OPTIONS = [
  {
    value: "not_specified",
    label: "Alle",
  },
  {
    value: "with_finta",
    label: "Mit FINTA Beteiligung",
  },
  {
    value: "only_finta",
    label: "Nur FINTA",
  },
];

export const GENDER_OPTIONS = [
  {
    value: "not_specified",
    label: "keine Angabe",
  },
  {
    value: "male",
    label: "männlich",
  },
  {
    value: "female",
    label: "weiblich",
  },
  {
    value: "nonbinary",
    label: "divers",
  },
];
